module.exports = __webpack_public_path__ + "img/c4logo.052feb86.png";